/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_Status_FailedInputs */

const en_academy_status_failed = /** @type {(inputs: Academy_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const ja_academy_status_failed = /** @type {(inputs: Academy_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不合格`)
};

const fr_academy_status_failed = /** @type {(inputs: Academy_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échoué`)
};

const de_academy_status_failed = /** @type {(inputs: Academy_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht bestanden`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Academy_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_status_failed = /** @type {((inputs?: Academy_Status_FailedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_Status_FailedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_status_failed(inputs)
	if (locale === "ja") return ja_academy_status_failed(inputs)
	if (locale === "fr") return fr_academy_status_failed(inputs)
	return de_academy_status_failed(inputs)
});